import {
  Dialog as MuiDialog,
  DialogProps as MuiDialogProps,
} from '@mui/material';
import useIsSmallScreen from '@/util/useIsSmallScreen';
import { CloseIconButton } from '../Button/IconButtons';

type DialogHeight = 'md' | 'lg';

export interface DialogProps extends MuiDialogProps {
  height?: DialogHeight;
  onCloseIcon?: () => void;
}

const presetHeights = {
  md: '800px',
  lg: '1200px',
};

const Dialog = ({ children, height, onCloseIcon, ...rest }: DialogProps) => {
  const isSmallScreen = useIsSmallScreen();
  const heightSx = height
    ? { height: presetHeights[height], maxHeight: '100%' }
    : {};

  return (
    <MuiDialog
      fullScreen={isSmallScreen}
      hideBackdrop={isSmallScreen}
      maxWidth="sm"
      fullWidth
      {...rest}
      slotProps={{
        paper: {
          sx: { ...heightSx, borderRadius: 3 },
        },
        ...rest.slotProps,
      }}
    >
      {onCloseIcon && (
        <CloseIconButton
          sx={{ position: 'absolute', right: 8, top: 8 }}
          onClick={onCloseIcon}
        />
      )}
      {children}
    </MuiDialog>
  );
};

export default Dialog;
